import Vue from "vue";
import { Ability } from "@casl/ability";
import DefaultAbility from "./default";
import AdminAbility from "./admin";
import ClientMainAbility from "./clientMain";
import ClientSubAbility from "./clientSub";

Vue.prototype.$ability = new Ability([]);

function getAbility(roles) {
  let ability = [...DefaultAbility];
  if (!roles) return ability;
  if (roles.includes("ADM") || roles.includes("SALES")) ability = [...ability, ...AdminAbility];
  if (roles.includes("CLNT")) ability = [...ability, ...ClientMainAbility, ...ClientSubAbility];
  if (roles.includes("CLNTSUB")) ability = [...ability, ...ClientSubAbility];

  return ability;
}

function updateAbility(user) {
  let roles = null;
  if (user) roles = [user.roleCode];
  const abilities = getAbility(roles);
  Vue.prototype.$ability.update(abilities);
}

function removeAbility() {
  Vue.prototype.$ability.update([]);
}

export default Vue.prototype.$ability;

export { getAbility, updateAbility, removeAbility };
